import { Injectable } from '@angular/core';
import {fromEvent, Observable } from 'rxjs';
import { TusUploadProgress } from './tus-upload-progress';
import * as tus from 'tus-js-client';
import {BasedataService} from '@docma-mm-core/shared/basedata.service';
import {ConfigService} from '@docma-mm-core/config/config.service';
import { HttpHeaders } from '@angular/common/http';
import {joinUrl} from '@docma-mm-core/utils/utils';
import {UploadOptions} from 'tus-js-client';

@Injectable({
  providedIn: 'root'
})
export class TusUploadService {

  constructor(private readonly configService: ConfigService) {
  }

  uploadFile(file: File): Observable<TusUploadProgress> {
    const endpoint = joinUrl(this.configService.getMmConfig().apiUrl, 'files');

    return new Observable<TusUploadProgress>(observer => {
      let upload: tus.Upload | undefined;

      const startUpload = async () => {
        upload = new tus.Upload(file, {
          endpoint,
          chunkSize: 2 * 1024 * 1024,
          parallelUploads: 1,
          retryDelays: [0, 3000, 5000, 10000],
          metadata: {
            filename: file.name,
            filetype: file.type,
          },
          storeFingerprintForResuming: true,

          onError: err => {
            if (!navigator.onLine) {
              console.log('Offline, waiting for reconnect...');
              return; // keep Observable alive
            }

            console.warn('Upload error:', err);
            observer.error(err);
          },

          onProgress: (uploaded, total) => {
            observer.next({
              uploaded,
              total,
              percentage: Math.round((uploaded / total) * 100),
            });
          },

          onSuccess: () => {
            observer.next({
              uploaded: file.size,
              total: file.size,
              percentage: 100,
              url: upload?.url,
              finished: true,
            });

            observer.complete();
          },
        });

        const previous = await upload.findPreviousUploads();

        if (previous.length > 0) {
          upload.resumeFromPreviousUpload(previous[0]);
        }

        console.warn('tus start (1)');
        upload.start();
      };

      console.warn('tus start (0)');

      // Fire and forget async initialization
      void startUpload().catch(err => observer.error(err));

      const subscription = fromEvent(window, 'online').subscribe(() => {
        if (upload) {
          console.log('Network reconnected, trying to resume upload...');
          upload.start();
        }
      });

      return () => {
        if (upload) {
          void upload.abort();
        }

        subscription.unsubscribe();
      };
    });
  }

}
